
const newModel = () => {
    return {
        vanhoaDiemDuLichId: null,
        ten: null,
        hinhAnh: null,
        linkHinhAnh: null,
        tenFileHinhAnh: null,
        tenPhuongXa: null,
        phuongXaId: null,
        diaChi: null,
        gpsLong: null,
        gpsLat: null,
        sdt: null,
        web: null,
        gioiThieu: null,
        gioMoCua: null,
        veVaoCong: null,
        quyetDinh: null,
        namHoatDong: null,
        namNgungHoatDong: null,
        loaiDiadiemId: null,
        tenLoaiDiadiem: null,
        tenPhanloaiDiadiem: null,
        phanloaiDiadiemId: null,
        ghiChu: null,
        stt: null,
        fListHinhAnh: null, //PostValue
        fileHinhAnhInfo: [], //GetValue
        enabled: null,
        enabledDisplay: null,
        // iocId: null,
        // iocEnabled: null,
        // iocEnabledDisplay: null,
        // iocDateUpdated: null,
        dateCreated: null,
        userCreated: null,
        dateModified: null,
        userModified: null,
        isDeleted: null,
        userDeleted: null,
        dateDeleted: null,
        tenUserCreated: null,
        tenUserModified: null,
        tenUserDeleted: null

    }
}

const newFEModel = () => {
    return {
        vanhoaDiemDuLichId: null,
        ten: null,
        hinhAnh: null,
        linkHinhAnh: null,
        tenFileHinhAnh: null,
        phuongXaId: null,
        diaChi: null,
        gpsLong: null,
        gpsLat: null,
        sdt: null,
        web: null,
        gioiThieu: null,
        gioMoCua: null,
        veVaoCong: null,
        quyetDinh: null,
        namHoatDong: null,
        namNgungHoatDong: null,
        
        loaiDiadiemId: null,
        phanloaiDiadiemId: null,
        ghiChu: null,
        fListHinhAnh: null, //PostValue
        fileHinhAnhInfo: [], //GetValue
        stt: "0",
        enabled: true,
    }
}

const fromJson = (item) => {
    return {
        vanhoaDiemDuLichId: item.vanhoaDiemDuLichId,
        ten: item.ten,
        hinhAnh: item.hinhAnh,
        linkHinhAnh: item.linkHinhAnh,
        tenFileHinhAnh: item.tenFileHinhAnh,
        tenPhuongXa: item.tenPhuongXa,
        phuongXaId: item.phuongXaId,
        diaChi: item.diaChi,
        gpsLong: item.gpsLong,
        gpsLat: item.gpsLat,
        sdt: item.sdt,
        web: item.web,
        gioiThieu: item.gioiThieu,
        gioMoCua: item.gioMoCua,
        veVaoCong: item.veVaoCong,
        quyetDinh: item.quyetDinh,
        namHoatDong: item.namHoatDong,
        namNgungHoatDong: item.namNgungHoatDong,
        loaiDiadiemId: item.loaiDiadiemId,
        tenLoaiDiadiem: item.tenLoaiDiadiem,
        tenPhanloaiDiadiem: item.tenPhanloaiDiadiem,
        phanloaiDiadiemId: item.phanloaiDiadiemId,
        ghiChu: item.ghiChu,
        stt: item.stt,
        fListHinhAnh: item.fListHinhAnh,
        fileHinhAnhInfo: item.fileHinhAnhInfo,
        xoaListHinhAnh: item.xoaListHinhAnh,
        enabled: item.enabled,
        dateCreated: item.dateCreated,
        userCreated: item.userCreated,
        dateModified: item.dateModified,
        userModified: item.userModified,
        isDeleted: item.isDeleted,
        userDeleted: item.userDeleted,
        dateDeleted: item.dateDeleted,
        tenUserCreated: item.tenUserCreated,
        tenUserModified: item.tenUserModified,
        tenUserDeleted: item.tenUserDeleted,
    }
}

const parseModeltoFEModel = (item) => {
    return {
        vanhoaDiemDuLichId: item.vanhoaDiemDuLichId,
        ten: item.ten,
        hinhAnh: item.hinhAnh,
        linkHinhAnh: item.linkHinhAnh,
        tenFileHinhAnh: item.tenFileHinhAnh,
        phuongXaId: item.phuongXaId,
        diaChi: item.diaChi,
        gpsLong: item.gpsLong,
        gpsLat: item.gpsLat,
        sdt: item.sdt,
        web: item.web,
        gioiThieu: item.gioiThieu,
        gioMoCua: item.gioMoCua,
        veVaoCong: item.veVaoCong,
        quyetDinh: item.quyetDinh,
        namHoatDong: item.namHoatDong,
        namNgungHoatDong: item.namNgungHoatDong,
        loaiDiadiemId: item.loaiDiadiemId,
        phanloaiDiadiemId: item.phanloaiDiadiemId,
        ghiChu: item.ghiChu,
        stt: item.stt,
        fListHinhAnh: item.fListHinhAnh,
        fileHinhAnhInfo: item.fileHinhAnhInfo,
        xoaListHinhAnh: item.xoaListHinhAnh,
        enabled: item.enabled,
    }
}

const newPagingSearchModel = () => {
    return {
        pageNumber: null,
        pageSize: null,
        sort: null,
        ten: null,
        phanloaiDiadiemId: null,
        phuongXaId: null,
        enabled: null,
    }

}

const newSearchModel = (item) => {
    return {
        ten: item.ten,
        phanloaiDiadiemId: item.phanloaiDiadiemId,
        phuongXaId: item.phuongXaId,
        enabled: item.enabled,
    }
}

const errors = () => {
    return {
        vanhoaDiemDuLichId: null,
        ten: null,
        hinhAnh: null,
        linkHinhAnh: null,
        tenFileHinhAnh: null,
        tenPhuongXa: null,
        phuongXaId: null,
        diaChi: null,
        gpsLong: null,
        gpsLat: null,
        sdt: null,
        web: null,
        gioiThieu: null,
        gioMoCua: null,
        veVaoCong: null,
        quyetDinh: null,
        namHoatDong: null,
        namNgungHoatDong: null,
        loaiDiadiemId: null,
        tenLoaiDiadiem: null,
        tenPhanloaiDiadiem: null,
        phanloaiDiadiemId: null,
        ghiChu: null,
        stt: null,
        enabled: null,
    }
}

export const diemDuLichVHModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    newPagingSearchModel,
    newSearchModel,
    fromJson,
    errors,
}


